import { render, staticRenderFns } from "./adddevice.vue?vue&type=template&id=1fc97811&scoped=true"
import script from "./adddevice.vue?vue&type=script&lang=js"
export * from "./adddevice.vue?vue&type=script&lang=js"
import style0 from "./adddevice.vue?vue&type=style&index=0&id=1fc97811&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc97811",
  null
  
)

export default component.exports